module.exports = __webpack_public_path__ + "img/lefthua_white.86b175bc.svg";